import { Cidade } from '../../../cidade';
import { Cliente } from '../cliente';

export interface IFiltrosAvancados {
  tiposPessoas: number[] | null;
  cnpjCpf: string | null;
  codigoIntegracaoErp: string | null;
  idClienteGrupoEconomico: number | null;
  origens: number[] | null;
  idsCanaisVendaOrigem: number[] | null;
  canaisMidiasSociais: number[] | null;
  idsCampanhasOrigens: number[] | null;
  idsCampanhasAquisicoes: number[] | null;
  idsPeriodicidadesCompras: number[] | null;
  periodicidadeCompraSemana: number[] | null;
  statusesAnaliseFinanceira: number[] | null;
  idsGerentes: number[] | null;
  idsAtendentes: number[] | null;
  dataCadastroInicial: string | null;
  dataCadastroFinal: string | null;
  clienteCentralCompras: Cliente | null;
  idsRegioes: number[] | null;
  idEstado: number[] | null;
  cidade: Cidade | null;
  idCidadeSubRegiao: number | null;
  idCidadeSubRegiaoBairro: number | null;
}

const isFilled = (value: unknown): boolean => {
  if (value == null) {
return false;
}
  if (Array.isArray(value)) {
return value.length > 0;
}
  if (typeof value === 'string') {
return value.trim().length > 0;
}
  return true;
};

const FILTROS_AVANCADOS_KEYS: ReadonlyArray<keyof IFiltrosAvancados> = [
  'tiposPessoas',
  'cnpjCpf',
  'codigoIntegracaoErp',
  'idClienteGrupoEconomico',
  'origens',
  'idsCanaisVendaOrigem',
  'canaisMidiasSociais',
  'idsCampanhasOrigens',
  'idsCampanhasAquisicoes',
  'idsPeriodicidadesCompras',
  'periodicidadeCompraSemana',
  'statusesAnaliseFinanceira',
  'idsGerentes',
  'idsAtendentes',
  'dataCadastroInicial',
  'dataCadastroFinal',
  'clienteCentralCompras',
  'idsRegioes',
  'idEstado',
  'cidade',
  'idCidadeSubRegiao',
  'idCidadeSubRegiaoBairro'
];

export function countFiltrosAvancados(current: Partial<IFiltrosAvancados>): number {
  return FILTROS_AVANCADOS_KEYS.filter((key) => isFilled(current[key])).length;
}
